import { toast } from 'react-toastify'
import CustomToast from '@/components/custom-toast'
import { ApiError, errorMessageFor } from '@/services/errors'

export const notifySuccess = (message: string) => {
  toast.success(<CustomToast title="Sucesso!" message={message} />)
}

export const notifyError = (message: string) => {
  toast.error(<CustomToast title="Erro!" message={message} />)
}

export const notifyWarning = (message: string) => {
  toast.warning(<CustomToast title="Atenção!" message={message} />)
}

export const notifyErrorFor = (acao: string, error?: unknown) => {
  const apiMessage = error instanceof ApiError ? error.message : null
  notifyError(apiMessage ?? errorMessageFor(acao))
}
